
<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <div class="container">

         <div class="form-group" style="margin-top: 30px">
            <router-link to="/serviceCategories/list" class="btn btn-default">{{ $t('Back') }}</router-link>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">{{ $t('Edit') }} </div>
            <div class="panel-body">
                <form v-on:submit.prevent="saveForm()">



                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label"> {{ $t('Title') }}</label>
                            <input type="text" v-model="item.title" class="form-control">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label">{{ $t('Description') }}</label>
                            <input type="text" v-model="item.description" class="form-control">
                        </div>
                    </div>



                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <button class="btn btn-success">{{ $t('Edit') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </div>
</template>

<script>


    const auth = {
        headers: {Authorization:'bearer ' + localStorage.getItem('token')}
    };


    export default {

        mounted() {
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get('/api/serviceCategories/' + id , app.auth)
                .then(function (resp) {
                    app.item = resp.data.data;
                })
                .catch(function () {
                    alert("بارگذاری دسته بندی ها امکان پذیر نیست");
//                    console.log('a: ' + auth)
                });









        },
        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                itemId: null,
                item: {
                    item: {
                        parent_id: '',
                        title: '',
                        image: null,
                        description: ''
                    },


                },

                errors: [],

            }
        },


        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                axios.patch('/api/serviceCategories/' + app.itemId, newItem , app.auth)
                    .then(function (resp) {
                        app.$snotify.success('آیتم با موفقیت ذخیره شد');

                        app.$router.replace('/serviceCategory/list');
                    })
                    .catch(function (e) {
                        app.errors.push(e.response.data.messages_fa);

//                            app.$snotify.warning(e.response.data.message);
                        console.log(e.response.data);


                        for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }

                    });
            }
        }
    }
</script>
